import styled, { css } from 'styled-components';
import { AssistiveTechnologyOnly } from '../../../styles/AssistiveTechnologyOnly';
import { variables } from '../../themes/variables';
import { media } from '../../themes/theme';
const backLinkStyle = css `
  @media (max-width: ${variables.screenTablet}px) {
    ${AssistiveTechnologyOnly}
  }
`;
export default styled.span `
  ${props => props.backLink && props.hideBackLinkTextOnMobile && backLinkStyle}

  line-height: 1.57;
  display: inline;
  font-family: ${props => props.theme.fonts.serif};
  font-size: 0.8125rem;
  font-weight: 300;
  color: ${({ theme, isCoupon, isWhiteTextLink, styling }) => isCoupon
    ? theme.colors.darkergrey
    : isWhiteTextLink
        ? theme.White
        : styling === 'secondaryTextlink'
            ? theme.colors.darkergrey
            : theme.BrandPrimary};
  transition: color 0.4s linear;

  ${({ styling }) => styling === 'secondaryTextlink' && 'text-decoration: underline;'};

  ${media.tablet `
    font-size: 0.875rem;
  `}

  &:hover {
    ${({ theme, isCoupon }) => !isCoupon && `color: ${theme.BrandPrimaryHover};`}
  }
`;
